var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKuwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_275_26187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 11,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02957 5.9707H18V12.1918H7.02957V5.9707Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_275_26187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8.99846C18 10.0499 17.8202 11.0592 17.4864 11.9989H7.04251V6.00049H17.4864C17.8177 6.93771 18 7.94703 18 8.99846Z",
    fill: "#F7F7F7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_275_26187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 11,
    width: 16,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4674 11.9844H17.6055V17.9998H2.4674V11.9844Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_275_26187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4864 11.999C16.2511 15.4936 12.9178 17.9998 8.99879 17.9998C6.52248 17.9998 4.28271 16.9994 2.65533 15.3842L7.04253 11.999H17.4864Z",
    fill: "#CE2029"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_275_26187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 16,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4674 0H17.6055V6.17821H2.4674V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_275_26187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4864 6.00081H7.04253L2.65533 2.61563C4.28271 1.0004 6.52491 0 8.99879 0C12.9178 0 16.2511 2.50385 17.4864 6.00081Z",
    fill: "#006F2E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_275_26187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 8,
    height: 14
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.44531H7.23694V15.5097H0V2.44531Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_275_26187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.04496 6.00041V12.0012L2.65533 15.384C1.0158 13.7542 0 11.4949 0 8.99838C0 6.50426 1.0158 4.24504 2.65533 2.61523L7.04496 6.00041Z",
    fill: "#1D1D1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuwait);
export default __webpack_public_path__ + "static/media/Kuwait.2993680800fdc2fc91f1af29c362ccfa.svg";
export { ForwardRef as ReactComponent };